import { LocationModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { defaultLocationModelDto } from './data/location.data';

export class RemoteDepositLocation extends DomainEntity<LocationModelDto> {
    constructor(dto = defaultLocationModelDto) {
        super(dto);
    }

    public get isEnabled() {
        return this.dto.isEnabled;
    }

    public get locationNumber() {
        return this.dto.locationNumber;
    }

    public get name() {
        return this.dto.name;
    }

    public get locationReference() {
        return this.dto.locationReference;
    }

    public createDefault(): this {
        return new RemoteDepositLocation(defaultLocationModelDto) as this;
    }
}
